<template>
  <a-space>
    <template v-if="formItem.type">
      <a-input  :id="formItem.id+'_input'" :disabled="!isEdit" @blur="valueChange"  v-model="form[formItem.id]" placeholder="请输入" v-if="formItem.type===elementTypeData.text.value" :maxLength="formItem.length || 100000" />
      <a-textarea   :id="formItem.id+'_input'" :disabled="!isEdit" @blur="valueChange" v-model="form[formItem.id]" placeholder="请输入" :rows="2"  v-else-if="formItem.type===elementTypeData.textarea.value" :maxLength="formItem.length || 100000"/>
      <template v-else-if="formItem.type===elementTypeData.number.value">
        <a-input-number    :disabled="!isEdit" :max="formItem.length || undefined" :readOnly="true" @blur="valueChange" v-model="form[formItem.id]" placeholder="请输入" :min="formItem.minLength || undefined" :precision="formItem.reDecimal==='1'?2:0" style="width: 100%"  />
      </template>
      <a-date-picker :disabled="!isEdit" :inputReadOnly="isPad" @change="valueChange" value-format='YYYY-MM-DD HH:mm:ss'
        show-time v-model="form[formItem.id]" allowClear v-else-if="formItem.type === elementTypeData.dateTime.value" />
      <a-radio-group :disabled="!isEdit" @change="valueChange" v-model="form[formItem.id]"
        v-else-if="formItem.type === elementTypeData.select.value">
        <!--<a-space>-->
        <a-radio @click="clickHandle(dictItem.value)" class="row-block" :value="dictItem.value"
          v-for="(dictItem, index) in dictItemList" :key="index">
          {{ dictItem.text }}
          <j-image-draw v-if="dictItem.img" :imgUrl="`${dictItem.img}`" />
        </a-radio>
        <!--</a-space>-->

      </a-radio-group>
      <a-checkbox-group :disabled="!isEdit" @change="valueChange" v-model="form[formItem.id]"
        v-else-if="formItem.type === elementTypeData.check.value">
        <!--<a-space>-->
        <a-checkbox class="row-block" :style="index === 0 ? { marginLeft: '8px' } : {}" :value="dictItem.value"
          v-for="(dictItem, index) in dictItemList" :key="index">
          {{ dictItem.text }}
          <j-image-draw v-if="dictItem.img" :imgUrl="`${dictItem.img}`" />
        </a-checkbox>
        <!--</a-space>-->

      </a-checkbox-group>
      <a-date-picker :disabled="!isEdit" :inputReadOnly="isPad" @change="valueChange" value-format='YYYY-MM-DD'
        v-model="form[formItem.id]" allowClear v-else-if="formItem.type === elementTypeData.date.value" />
      <a-time-picker class="main" :disabled="!isEdit" :inputReadOnly="isPad" @change="valueChange" value-format='HH:mm'
        format="HH:mm" v-model="form[formItem.id]" :open.sync="timeOpen" allowClear
        v-else-if="formItem.type === elementTypeData.time.value">
        <a-button slot="addon" size="small" type="primary" @click="handleTimeClose">
          关闭
        </a-button>
      </a-time-picker>
      <div v-else-if="formItem.type === elementTypeData.qrCode.value">
        扫码功能暂未开放
      </div>
      <div v-else-if="formItem.type === elementTypeData.file.value">
        <div>
          {{ form[formItem.id] }}
        </div>
        <a-upload name="file" class="main" :disabled="!isEdit" :showUploadList="false" :multiple="false"
          :headers="tokenHeader" :data="{ biz: `/project/${projectId}/patient/form/${formItem.id}/${fileType}` }"
          :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" icon="import">上传文件</a-button>
        </a-upload>
      </div>
      <a-row v-else-if="formItem.type === elementTypeData.slider.value" style="float: left" :id="formItem.id + '_input'">
        <a-col :span="18">
          <a-slider   :disabled="!isEdit" @afterChange="valueChange" :marks="marks" v-model="form[formItem.id]" :min="formItem.minLength||0" :max="formItem.length||100"/>
        </a-col>
        <a-col :span="4" style="margin-top: 10px">
          <a-input-number v-model="form[formItem.id]" :min="formItem.minLength||0" :max="formItem.length||100" style="margin-left: 100px" :disabled="true" />          
        </a-col>
      </a-row>
      <div v-else>
        未知的元素
      </div>
    </template>
    <template v-else>
      1
    </template>
    <label v-if="formItem">{{ formItem.unit || '' }}</label>
    <a-tooltip placement="topLeft" v-if="formItem.description">
      <template slot="title">
        {{ formItem.description }}
      </template>
      <a-icon type="info-circle" style="color: red" />
    </a-tooltip>
  </a-space>
</template>

<script>
import JImageDraw from '@/components/jeecg/JImageDraw'
import { elementTypeData, CACHE_PROJECT_ID, CACHE_IS_PAD } from '@/constants/project'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'

export default {
  name: 'BaseFormViewItemInput',
  components: { JImageDraw, },
  props: {
    formItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    enforcement: { //强制修改
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      projectId: Vue.ls.get(CACHE_PROJECT_ID),
      isPad: Vue.ls.get(CACHE_IS_PAD),
      elementTypeData: elementTypeData,
      timeOpen: false,
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      fileType: '2',
      open: false,

    }
  },
  created() {
    
  },  
  computed: {
    dictItemList() {
      if (this.formItem.dictItemJson) {
        return JSON.parse(this.formItem.dictItemJson)
      }
      return []
    },
    isTemplate() {
      return !this.formItem.formItemId
    },
    isEdit() {
      return this.enforcement || (!this.readOnly && this.formItem.disabled !== '1') || this.isTemplate
    },
    marks() {
      const length = this.formItem.length||100
        const minLength = this.formItem.minLength || 0
        const half = parseInt((length - minLength) / 2)        
        const marks = {
          0:`${minLength}`
        }
        if(half>0){
          marks[half+minLength] = `${half + minLength}`
        }
        marks[length] = `${length}`
        return marks
    },
    importExcelUrl() {
      return `${window._CONFIG['domianURL']}/sys/common/upload`
    }
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        const div = document.getElementById(this.formItem.id + '_input')
        if (div && div.parentNode && div.parentNode.parentNode) {
          const sParent = div.parentNode.parentNode
          div.style.width = (sParent.clientWidth * 0.9) + 'px'
        }

      })
    }, 1)
  },
  methods: {    
    valueChange() {
      this.$emit('valueChange', { id: this.formItem.id, code: this.formItem.code, name: this.formItem.name }, this.form[this.formItem.id])
    },
    handleTimeClose() {
      this.timeOpen = false
    },
    clickHandle(value) {
      this.$nextTick(() => {
        if (this.form[this.formItem.id] === value) {
          this.form[this.formItem.id] = null;
        }
      })
      // if(this.form[this.formItem.id]!==undefined &&this.form[this.formItem.id]!=null ){
      //   this.form[this.formItem.id] = null
      // }
    },
    handleImportExcel(fileInfo) {
      const file = fileInfo.file
      if (file.status === 'done' && file.response && file.response.success) {
        const filePath = file.response.message
        this.$set(this.form, this.formItem.id, filePath)
      }

    },
  }
}
</script>

<style scoped lang="less">
.row-block {
  display: block;
  line-height: 30px;
  float: left;
}
</style>